import styled from "styled-components";

export const TriggerButton = styled.div`
    display: flex;
    align-self: center;
    justify-content: center;
    padding: 2px;
    margin-top: 2px;
    color: ${({ theme }) => theme.layouts.mainLayout.triggerButton.iconColor};
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.25s;

    &:hover {
        color: ${({ theme }) => theme.layouts.mainLayout.triggerButton.iconHoverColor};
        background-color: ${({ theme }) => theme.layouts.mainLayout.triggerButton.bgHoverColor};
    }
`;
